import React from "react";

interface HomeWorkContextProps {
    reloadPaper: () => void;
}

export const HomeWorkContext = React.createContext<HomeWorkContextProps>({
    reloadPaper: () => null
});
